import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { FiltersLabel } from '../../../search/FiltersModal/Filters.styles';
import {
    DropdownWrapper,
    RightWrapper,
    LeftWrapper
} from '../../../search/common/Dropdown.styles';
import {
    ForSalePriceMinSelectOptions,
    ForSalePriceMaxSelectOptions
} from '../../../search/common/SelectPriceOptions';
import {
    updateFilter,
    minPriceSelector,
    maxPriceSelector
} from '../../../reducers/filters';
import { FilterWrapper } from './SearchInitiationMobileModal.styles';

export const SelectPriceForSale: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: priceMinSelectedValue,
        options: priceMinOptions
    } = useSelector(minPriceSelector);

    const {
        selectedValue: priceMaxSelectedValue,
        options: priceMaxOptions
    } = useSelector(maxPriceSelector);

    const priceMinInt = parseInt(priceMinSelectedValue || '0', 10);
    const priceMaxInt = parseInt(priceMaxSelectedValue || '0', 10);

    const onMaxPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('maxPrice', evt.currentTarget.value));
    };

    const onMinPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('minPrice', evt.currentTarget.value));
    };

    const priceRangeLabel = 'Price range';
    const priceOptionLabel = 'Any price';
    const maxPriceLabel = 'Max price';
    const minPriceLabel = 'Min price';

    return (
        <FilterWrapper>
            <FiltersLabel htmlFor="modal-price-filter">
                {priceRangeLabel}
            </FiltersLabel>
            <DropdownWrapper>
                <LeftWrapper>
                    <DropdownWithLabel
                        id="price_min_mobile"
                        onChange={onMinPriceChange}
                        value={priceMinSelectedValue}
                        name="price_min"
                        aria-label="Min Price"
                        data-testid="min_price_testid_modal_mobile"
                        label={minPriceLabel}
                        hasBorderRadius
                    >
                        {priceMinOptions ? (
                            <ForSalePriceMinSelectOptions
                                options={priceMinOptions}
                                priceOtherInt={priceMaxInt}
                                keyPrefix="modal-pricemin"
                            />
                        ) : (
                            <option key="modal-price_min">
                                {priceOptionLabel}
                            </option>
                        )}
                    </DropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <DropdownWithLabel
                        id="price_max_mobile"
                        onChange={onMaxPriceChange}
                        value={priceMaxSelectedValue}
                        name="price_max"
                        aria-label="Max Price"
                        data-testid="max_price_testid_modal_mobile"
                        label={maxPriceLabel}
                        hasBorderRadius
                    >
                        {priceMaxOptions ? (
                            <ForSalePriceMaxSelectOptions
                                options={priceMaxOptions}
                                priceOtherInt={priceMinInt}
                                keyPrefix="modal-pricemax"
                            />
                        ) : (
                            <option key="modal-price_max">
                                {priceOptionLabel}
                            </option>
                        )}
                    </DropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
